export default "__VITE_ASSET__DHAnx$2o__"